import {Checkbox, MenuItem, SelectField} from 'material-ui';
import FlatButton from 'material-ui/FlatButton';
import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import styled from 'styled-components';

import {HeadlineH1, HeadlineH2} from '../arkulpa-fec/components/Text';
import {Label} from '../arkulpa-fec/components/FormElements';
import {convertErrors} from '../arkulpa-fec/utils/errorHelper';
import {getContentDefinition, getContentTypes} from '../contentDefinitions';
import ActionButtonRow from '../arkulpa-fec/components/ActionButtonRow';
import ContentBuilder from '../arkulpa-fec/components/Content/ContentBuilder';
import DeleteModal from '../arkulpa-fec/components/DeleteModal';
import ErrorMessage from '../arkulpa-fec/components/ErrorMessage';
import LoadingIndicator from '../arkulpa-fec/components/LoadingIndicator';
import MediaPicker from '../arkulpa-fec/components/MediaPicker/MediaPicker';
import config from '../config';
import filterOutNotDefinedValues from '../arkulpa-fec/utils/filterOutNotDefinedValues';

const ColoredSection = styled.section`
  background: #efefef;
  margin: 40px -40px;
  padding: 30px 40px;
`;

export default class extends Component {
  constructor(props) {
    super(props);
    let {content, allSnippets} = props.data || {};
    this.state = {
      project: config.getProjectKey(),
      type: 'default',
      title: '',
      slug: '',
      teaser: '',
      content: {},
      ogImage: null,
      attachments: null,
      seoTitle: '',
      seoDescription: '',
      position: 0,
      linkedToIndex: false,
      allSnippets: allSnippets,
      deleteModalOpen: false,
      ...filterOutNotDefinedValues(content),
    };
  }

  componentWillReceiveProps = newProps => {
    let {error, content, allSnippets} = newProps.data || {};
    if (error) {
      const {graphQLErrors} = error || {};
      this.setState({errors: graphQLErrors});
    } else {
      this.setState({errors: [], ...filterOutNotDefinedValues(content), allSnippets: allSnippets});
    }
  };

  _goBackToList = () => this.props.history.goBack();

  _renderHeadline = () => {
    if (this._isNew()) {
      return <HeadlineH1>Neuer Content</HeadlineH1>;
    }
    return <HeadlineH1>Content bearbeiten</HeadlineH1>;
  };

  _isNew = () => !this.props.match.params.id;

  _changeContent = (key, value) => {
    const {content} = this.state;
    this.setState({content: {...content, [key]: value}});
  };

  handleContentTypeChange = (event, index, value) => {
    this.setState({
      type: value,
    });
  };

  _save = () => {
    const {ogImage, attachments, snippets, deleteModalOpen, ...state} = filterOutNotDefinedValues(this.state);
    this.props
      .save({
        attachments: attachments && attachments.length ? attachments.map(media => media._id) : [],
        ogImage: ogImage ? ogImage._id : null,
        ...state,
      })
      .then(() => this._goBackToList())
      .catch(rawErrors => {
        let errors = convertErrors(rawErrors);
        this.setState({errors});
        console.log('there was an error sending the query', errors);
      });
  };

  _delete = () => {
    const {_id} = this.state;
    this.props
      .delete(_id)
      .then(() => this._goBackToList())
      .catch(rawErrors => {
        let errors = convertErrors(rawErrors);
        this.setState({errors});
        console.log('there was an error while deleting the entity', errors);
      });
  };
  _renderContentType = () => {
    const contentTypes = getContentTypes();
    if (!contentTypes.length) {
      return <div>!!contentTypes not defined!!</div>;
    }
    return (
      <SelectField floatingLabelText="contentType" value={this.state.type} onChange={this.handleContentTypeChange}>
        {contentTypes.map(type => <MenuItem key={type} value={type} primaryText={type} />)}
      </SelectField>
    );
  };

  render() {
    let {
      project,
      type,
      title,
      slug,
      content,
      seoTitle,
      seoDescription,
      position,
      linkedToIndex,
      attachments,
      ogImage,
      allSnippets,
    } = this.state;
    if (this.props.data && this.props.data.loading) {
      return <LoadingIndicator />;
    }

    return (
      <div>
        <ErrorMessage errors={this.state.errors} clearErrors={() => this.setState({errors: []})} />
        {this._renderHeadline()}
        {this._renderContentType()}
        <ColoredSection>
          <TextField
            type="text"
            fullWidth={true}
            floatingLabelText="Title*"
            value={title}
            onChange={({target: {value}}) => this.setState({title: value})}
          />
          <TextField
            type="text"
            fullWidth={true}
            floatingLabelText="Url*"
            value={slug}
            onChange={({target: {value}}) => this.setState({slug: value})}
          />

          <Label>Teaser</Label>
          {/* <ArkEdit value={teaser} onChange={value => this.setState({teaser: value})} /> */}
        </ColoredSection>
        <HeadlineH2 margin="0 0 1em">Inhalt</HeadlineH2>
        <ContentBuilder
          contentDefinition={getContentDefinition(project, type)}
          values={content}
          changeValue={this._changeContent}
          config={config}
          allSnippets={allSnippets}
        />
        <ColoredSection>
          <HeadlineH2 margin="0 0 1em">Metadaten</HeadlineH2>
          <MediaPicker
            config={config}
            multiple={false}
            type={'image'}
            title="OG Image"
            values={ogImage}
            onSelect={medias => {
              this.setState({ogImage: medias.length ? medias[0] : null});
            }}
          />

          <TextField
            type="text"
            fullWidth={true}
            floatingLabelText="SEO Title"
            value={seoTitle}
            onChange={({target: {value}}) => this.setState({seoTitle: value})}
          />
          <TextField
            type="text"
            fullWidth={true}
            floatingLabelText="SEO Description"
            multiLine={true}
            value={seoDescription}
            onChange={({target: {value}}) => this.setState({seoDescription: value})}
          />
        </ColoredSection>
        <HeadlineH2 margin="0 0 1em">Zusätzliche Informationen</HeadlineH2>
        <MediaPicker
          multiple={true}
          config={config}
          type={'other'}
          title="Downloads"
          values={attachments}
          onSelect={medias => {
            this.setState({attachments: medias});
          }}
        />
        <Checkbox
          label="Auf Startseite verlinkt"
          checked={linkedToIndex}
          style={{marginTop: 20, marginBottom: 10}}
          onCheck={() => {
            this.setState({linkedToIndex: !linkedToIndex});
          }}
        />
        <TextField
          type="text"
          fullWidth={true}
          floatingLabelText="Position"
          value={position}
          onChange={({target: {value}}) => this.setState({position: value ? parseInt(value, 10) : ''})}
        />
        <ActionButtonRow>
          <FlatButton onClick={this._goBackToList} label="Zurück zur Übersicht" />
          <div>
            {!this._isNew() && <FlatButton onClick={() => this.setState({deleteModalOpen: true})} label="löschen" />}

            <FlatButton primary onClick={this._save} label="speichern" />
          </div>
        </ActionButtonRow>
        <DeleteModal
          onCancel={() => {
            this.setState({deleteModalOpen: false});
          }}
          onConfirm={this._delete}
          open={this.state.deleteModalOpen}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContentForm.js